import { Types } from '@scorenco/core';

import { Wrapper } from '../../primitives';

type AdvertisingSliceProps = {
  slice: Types.ComponentSlicesAdvertising;
};

export const AdvertisingSlice = ({ slice }: AdvertisingSliceProps) => {
  return (
    <Wrapper marginY={5}>
      <div id={slice.advertising_id}></div>
    </Wrapper>
  );
};
